<div class="card rounded-lg p-1 border-0">
  <div class="d-flex justify-content-start">
    <button class="btn btn-secondary-dark btn-sm rounded-small text-xxs shadow text-dark mt-3 ms-3"
      data-bs-toggle="modal" data-bs-target="#create_invoice">Create Invoice</button>
  </div>
  <div
    class="glassy-table border-0 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center rounded-lg">

    <div class="card-body">
      <GlobalTable v-if="created_invoice.length"
        :headers="['No', 'Invoice Name', 'Date Generated', 'Date Due', 'Status']" :data="created_invoice"
        table_id="invoice">
        <template #actions="{ row }">
          <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" data-bs-toggle="modal"
            data-bs-target="#preview_invoice">Preview</button>
        </template>
      </GlobalTable>
    </div>
  </div>
</div>

<!--Create invoice modal-->
<teleport to="body">
  <div class="modal fade" id="create_invoice" ref="invoiceModal" tabindex="-1" aria-labelledby="create_invoice_label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs" id="create_invoice_label">Create invoice</p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div>
            <h4 class="fw-bold mb-3 text-xxs">Invoice Details</h4>
            <div class="row g-3 mb-4">
              <div class="col-md-6">
                <label class="modal-form-label form-label text-xxs">Invoice Date</label>
                <input class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" type="date" v-model="company_name" />
              </div>
              <div class="col-md-6">
                <label class="modal-form-label form-label text-xxs">Due Date</label>
                <input class="modal-form-control form-control text-xxs rounded-small p-2 shadow-sm" type="date" v-model="invoice_description" />
              </div>
            </div>

            <h5 class="fw-bold mb-3 mt-5 text-xxs">Invoice Items</h5>
            <div class="table-responsive">
              <table class="table align-middle">
                <thead>
                  <tr class="text-xxs">
                    <th>Description</th>
                    <th>Quantity</th>
                    <th>Rate</th>
                    <th>Tax</th>
                    <th>Amount</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="text-xxs" v-for="(item, index) in invoice_items" :key="index">
                    <td><input type="text" class="form-control text-xxs" v-model="item.description" /></td>
                    <td><input type="number" class="form-control text-xxs" v-model.number="item.quantity" /></td>
                    <td><input type="number" class="form-control text-xxs" v-model.number="item.rate" /></td>
                    <td> <input type="checkbox" v-model="item.taxable"></td>
                    <td class="text-xxs">R{{ (item.quantity * item.rate).toFixed(2) }}</td>
                    <td><button class="btn btn-sm btn-light text-danger text-xxs" @click="remove_item(index)">&times;</button></td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="mb-3">
              <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" @click="add_item">Add items</button>
            </div>

            <div class="d-flex justify-content-end text-end text-xxs">
              <div>
                <p>Subtotal <strong>R{{ subtotal.toFixed(2) }}</strong></p>
                <p>Tax(15%) <strong>R{{ tax.toFixed(2) }}</strong></p>
                <p>Total <strong>R{{ total.toFixed(2) }}</strong></p>
              </div>
            </div>

            <div class="d-flex justify-content-end gap-2 mt-4 text-xxs">
              <button class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" >Genarate invoice</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>

<!-- preview and sendout the invoice -->
<teleport to="body">
  <div class="modal fade" id="preview_invoice" ref="invoiceModal" tabindex="-1" aria-labelledby="create_invoice_label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p class="modal-title text-white text-xxs" id="create_invoice_label">Preview</p>
          <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <PreviewInvoice />
        </div>
      </div>
    </div>
  </div>
</teleport>